import i from "./index.ce.vue.js";
import { defineAndRegisterElement as o } from "../../utils/register-element.js";
const r = o(i);
export {
  r as initAiModifyDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-modify-dialog/index.js
// module id = 1159
// module chunks = 41